module.exports = __webpack_public_path__ + "img/step11_pink.ee856975.png";